// extracted by mini-css-extract-plugin
module.exports = {"button":"NotesStyles_button__2g744","notes":"NotesStyles_notes__3nTAw","note":"NotesStyles_note__2zxh5","paper":"NotesStyles_paper__2uCbj"};